export default __webpack_public_path__ + "img/39ffdb7e8913ed231faf7f088f5dd800.png";